import CtrlStatus from './pages/CtrlStatusPage.vue'

const routes = [
  {
    path: 'ctrl-status',
    name: 'ctrl-status',
    component: CtrlStatus
  }
];

export default routes;